export const accountInsulinCollectionKey = "account_insulins"
export const accountMedicationCollectionKey = "account_medications"
export const entryTemplateCollectionKey = "entry_templates"
export const insulinCollectionKey = "insulins"
export const medicationCollectionKey = "medications"
export const userEntryCollectionKey = "user_entries"
export const userEventCollectionKey = "user_events"
